export default "__VITE_ASSET__C7AmMXiX__"